import { FormGroup, Heading, Radio, RadioGroup } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { ActivityType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { ISearchParams } from '../requestFinancialExportUtils';

enum ActivityTypeChoiceAll {
    all = 'all',
}

interface IRequestFinancialExportActivityFilterProps {
    activityTypeChoice?: ActivityType | ActivityTypeChoiceAll;
    errors: ValidationErrors;
    isDisabled: boolean;
    onChange: (filterName: keyof ISearchParams, value?: string) => void;
}

export function RequestFinancialExportActivityFilter(props: IRequestFinancialExportActivityFilterProps) {
    const language = getSelectedLanguage();

    const radioOptions = [
        {
            label: language.common.all,
            value: ActivityTypeChoiceAll.all,
        },
        {
            label: language.activityTypeEnum.request,
            value: ActivityType.request,
        },
        {
            label: language.activityTypeEnum.biometrics,
            value: ActivityType.biometrics,
        },
        {
            label: language.activityTypeEnum.grading,
            value: ActivityType.grading,
        },
        {
            label: language.activityTypeEnum.qualityControl,
            value: ActivityType.qualityControl,
        },
        {
            label: language.activityTypeEnum.consultation,
            value: ActivityType.consultation,
        },
    ];

    return (
        <>
            <Heading
                marginY={3}
                size="small"
            >
                {language.common.activity}
            </Heading>
            <FormGroup
                isRequired={true}
                label={language.finance.chooseActivities}
            >
                <RadioGroup
                    name={'activityTypeChoice'}
                    onChange={handleRadioChange}
                    value={props.activityTypeChoice ?? ActivityTypeChoiceAll.all}
                >
                    {radioOptions.map((option) => (
                        <Radio
                            disabled={props.isDisabled}
                            key={option.value}
                            label={option.label}
                            value={option.value}
                        />
                    ))}
                </RadioGroup>
            </FormGroup>
        </>
    );

    function handleRadioChange(event: React.ChangeEvent<HTMLInputElement>) {
        props.onChange(
            'activityTypeChoice',
            event.target.value === ActivityTypeChoiceAll.all ? undefined : event.target.value
        );
    }
}
